<script>

export default {
  name: 'VoyageTable',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      default: () => ({
        current: 1,
        pageSize: 20,
        totalSize: 0,
      }),
    },
    confirmingDeleteId: [Number, String],
  },
  methods: {
    formatCargoStatus(value) {
      return value ? 'With Cargo' : 'No Cargo';
    },
    handlePageChange(page) {
      this.$emit('page-changed', page);
    },
    handleRefresh() {
      this.$emit('refresh');
    },
    handleAdd() {
      this.$emit('add');
    },
    handleView(item) {
      this.$emit('view', item);
    },
    handleEdit(item) {
      this.$emit('edit', item);
    },
    handleDelete(item) {
      this.$emit('delete', item);
    },
  },
};
</script>

<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Voyage List</h5>
      <div>
        <b-button
          v-if="canCreate('voyage_master')"
          variant="primary"
          class="mr-2"
          @click="handleAdd"
        >
          Add New Voyage
        </b-button>
        <b-button
          variant="outline-secondary"
          @click="handleRefresh"
        >
          <b-icon icon="arrow-clockwise" font-scale="1"></b-icon>
        </b-button>
      </div>
    </div>

    <div v-if="loading" class="text-center">
      <p>Loading...</p>
    </div>

    <b-table
      v-else
      striped
      hover
      responsive
      :items="items"
      :fields="fields"
      show-empty
    >
      <template #empty>
        <div class="text-center">
          <p>No data available.</p>
        </div>
      </template>

      <template #cell(actions)="data">
        <b-button
          variant="info"
          size="sm"
          class="mr-1"
          @click="$emit('view', data.item)"
        >
          Detail
        </b-button>
        <b-button
          v-if="canUpdate('voyage_master')"
          variant="warning"
          size="sm"
          class="mr-1"
          @click="$emit('edit', data.item)"
        >
          Edit
        </b-button>
        <b-button
          v-if="canDelete('voyage_master')"
          size="sm"
          :variant="confirmingDeleteId === data.item.mvygId ? 'danger' : 'outline-danger'"
          @click="$emit('delete', data.item)"
          @mouseleave="$emit('update:confirmingDeleteId', null)"
        >
          {{ confirmingDeleteId === data.item.mvygId ? 'Confirm?' : 'Delete' }}
        </b-button>
      </template>
    </b-table>

    <b-pagination
      v-if="items && items.length > 0"
      v-model="pagination.current"
      :per-page="pagination.pageSize"
      :total-rows="pagination.totalSize"
      @change="handlePageChange"
    ></b-pagination>
  </div>
</template>
